import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import SelectContainer from "~/components/SelectContainer/SelectContainer";
import { getProjectTemplateById } from "~/store/selectors/selector.projectTemplates";
import { getActiveUsersMembersByUserIdsSelector } from "~/store/selectors/selector.users";
import { TemplateTaskPanelItem } from "./TemplateTaskPanelItem";
import { resolvedMembersForAssigneePicker } from "../../utils";

export const TemplateTaskAssigneePicker = ({ task, onChange }) => {
  const { t } = useTranslation();

  const template = useSelector((state) => getProjectTemplateById(state, task?.template_id));
  const members = useSelector((state) => getActiveUsersMembersByUserIdsSelector(state, template?.get("members") || []));

  const handleChange = (id) => {
    onChange({ assignee_id: id });
  };

  return (
    <TemplateTaskPanelItem label={t("Assignee")}>
      <SelectContainer
        placeholder={t("Choose an assignee")}
        defaultValue={t("No Assignee...")}
        selected={task?.assignee_id > 0 ? task.assignee_id : undefined}
        options={resolvedMembersForAssigneePicker(members, task?.is_hidden_from_clients)}
        onChange={handleChange}
        className="tw-w-full"
      />
    </TemplateTaskPanelItem>
  );
};

TemplateTaskAssigneePicker.propTypes = {
  task: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
